import CanNotRemoveModal from "@/components/can-not-remove-modal.vue"
import YesNoModal from "@/components/yes-no-modal.vue"

export default {
  
  data() {
    return {
      allowMultiple: true,
      autofocus: false,
      restoreFocus: false,
      loading: false,
      saving: false,
      checkingName: false,
      checkingRemoval: false,
      removing: false,
      isCreating: false,
      isUpdating: false,
      emitEvent: null,
      confirmNameMessage: "",
    }
  },

  components: { 
    CanNotRemoveModal, 
    YesNoModal,
  },

  computed: {

    modalSelector() {
      return this._uid + "_modal"
    },
  },

  mounted() {    

    let settings = {
      autofocus: this.autofocus,
      restoreFocus: this.restoreFocus,
      allowMultiple: this.allowMultiple,
      onHidden: this.onHidden,      
    }

    if (this.onShow)
      settings.onShow = this.onShow

    if (this.onVisible)
      settings.onVisible = this.onVisible

    $("#" + this._uid).modal(settings)
  },

  beforeDestroy() {
    $("." + this.modalSelector).remove()
  },

  methods: {

    reset() {
      this.loading = false
      this.saving = false
      this.checkingRemoval = false
      this.removing = false
      this.isCreating = false
      this.isUpdating = false
      this.emitEvent = null
    },

    emit(event, data) {
      this.emitEvent = { event, data }
      this.hide()
    },

    create(data) {      
      this.reset()
      this.isCreating = true
      this.load(data)
    },

    update(data) {
      this.reset()
      this.isUpdating = true
      this.load(data)
    },

    show() {      
      $("#" + this._uid).modal("show")
    },

    hide() {
      $("#" + this._uid).modal("hide")
    },

    onHidden() {      
      if (this.emitEvent) {
        const emitEvent = this.$cloneObject(this.emitEvent)
        this.$emit(emitEvent.event, emitEvent.data)
        this.emitEvent = null
      }  
    },
  },
}